import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import moment from 'moment';

@Component({
  selector: 'shared-filter-panel-months',
  templateUrl: './filter-panel-months.component.html',
  styleUrls: ['./filter-panel-months.component.scss'],
  host: { class: 'shared-filter-panel-months' },
})
export class SharedFilterPanelMonthsComponent implements OnInit {
  @Input() months: Filter[] = [];
  @Input() selectMulti = false;
  @Output() monthsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() { }

  allMonths!: Date[];

  ngOnInit() {
    this.loadMonths();
  }

  getDisplayName(month: Date): string {
    const mDate = moment(month);
    return mDate.utc().format("MMMM YYYY");
  }

  getValue(month: Date): string {
    return month.toISOString().substring(0, 10);
  }

  addProduct(month: Date) {
    // if not in multi mode then clear selected.
    if (this.selectMulti === false) this.clear();

    if (!this.months.find((sp) => this.getValue(new Date(sp.value)) === this.getValue(month))) {
      this.months.push({
        value: this.getValue(month),
        displayName: this.getDisplayName(month),
        type: 'month',
      } as Filter);
    }
    this.monthsChange.emit(this.months);
  }

  removeProduct(month: Date) {
    const index = this.months.findIndex((sp) => this.getValue(new Date(sp.value)) === this.getValue(month));
    if (index > -1) {
      this.months.splice(index, 1);
    }
    this.monthsChange.emit(this.months);
  }

  clear() {
    this.months = [];
    this.monthsChange.emit(this.months);
  }

  isSelected(month: Date): boolean {
    if (!this.months) return false;
    if (this.months.find((sp) => this.getValue(new Date(sp.value)) === this.getValue(month))) return true;
    else return false;
  }

  loadMonths() {
    const endMonth = new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1));
    const startMonth = new Date(endMonth.getTime());
    endMonth.setUTCDate(120);
    startMonth.setUTCDate(-186);

    this.allMonths = this.monthRange(startMonth, endMonth);
  }

  private monthRange(startDate: Date, endDate: Date) {
    const fromYear = startDate.getUTCFullYear();
    const fromMonth = startDate.getUTCMonth();
    const toYear = endDate.getUTCFullYear();
    const toMonth = endDate.getUTCMonth();
    const months = [];

    for (let year = fromYear; year <= toYear; year++) {
      let monthNum = year === fromYear ? fromMonth : 0;
      const monthLimit = year === toYear ? toMonth : 11;

      for (; monthNum <= monthLimit; monthNum++) {
        const month = monthNum;
        months.push(new Date(Date.UTC(year, month, 1)));
      }
    }
    return months;
  }
}
